/**
 * Component Presets
 * Defines preset enum types for all components
 */

export enum TextPreset {
  Regular = 'regular',
  Strong = 'strong',
  Mild = 'mild',
  Accent = 'accent',
  ChipVersion = 'chipVersion',
  ChipDent = 'chipDent',
}

export enum ContainerPreset {
  Default = 'default',
  Active = 'active',
  Hollow = 'hollow',
  Card = 'card',
  Secondary = 'secondary',
  Elevated = 'elevated',
  Modern1 = 'modern-1',
  Tile = 'tile',
  TileGradient = 'tileGradient',
  ModalCard = 'modalCard',
  HalfGlass = 'half-glass',
  HalfGlass2 = 'half-glass-2',
  ModernFaded = 'modern-faded',
  TextInput = 'textInput',
  ChipVersion = 'chipVersion',
  ChipDent = 'chipDent',
  InnerWindow = 'innerWindow',
  WitnessCard = 'witnessCard',
  Blackish = 'blackish',
  DarkInset = 'dark-inset',
  Mysterious = 'mysterious',
}

export enum IconPreset {
  Default = 'default',
  Active = 'active',
  Inactive = 'inactive',
  Small = 'small',
  Large = 'large',
}

export enum ChipPreset {
  Active = 'active',
  Hollow = 'hollow',
  Inactive = 'inactive',
  Primary = 'primary',
  Secondary = 'secondary',
  MenuCard = 'menuCard',
  Version = 'version',
  Dent = 'dent',
}

export enum ButtonPreset {
  Primary = 'primary',
  Secondary = 'secondary',
  Secondary2 = 'secondary2',
  Ghost = 'ghost',
  Dark = 'dark',
  SleekAccent = 'sleek-accent',
  ModernPrimary = 'modern-primary',
  GlowPrimary = 'glow-primary',
  TabActive = 'tabActive',
  TabInactive = 'tabInactive',
  Danger = 'danger',
  Embossed = 'embossed',
}

export enum ModalLocation {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}

export enum ModalVisualMode {
  Gradient = 'gradient',
  Dark = 'dark',
}

export enum ModalHorizontalMode {
  Stretched = 'stretched',
  Centered = 'centered',
}

export enum MarkdownHeadingPreset {
  Level1 = 'level1',
  Level2 = 'level2',
  Level3 = 'level3',
  Level4 = 'level4',
  Level5 = 'level5',
  Level6 = 'level6',
}

export const NAVBAR_HEIGHT = 64; // pixels
